import { render, staticRenderFns } from "./PanelDoz.vue?vue&type=template&id=04e7f313&scoped=true&"
import script from "./PanelDoz.vue?vue&type=script&lang=js&"
export * from "./PanelDoz.vue?vue&type=script&lang=js&"
import style0 from "./PanelDoz.vue?vue&type=style&index=0&id=04e7f313&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e7f313",
  null
  
)

export default component.exports